<td>
  <div class="runner">
    <span class="name">{{ market?.runnerName }}</span>
    <div class="pnl">
      @let runnerNetEffect = runnerNetEffect$ | async;
      @let runnerPNetEffect = runnerPNetEffect$ | async;
      @if (runnerNetEffect || runnerPNetEffect) {
        <span>Max Exposure:</span>
      }
      @if (!isNil(runnerNetEffect)) {
        <b
          [ngClass]="{
            'pnl-green': runnerNetEffect >= 0,
            'pnl-red': runnerNetEffect < 0,
          }"
          >&nbsp;{{ runnerNetEffect | number: "1.2-2" }}</b
        >
      }
      @if (!isNil(runnerPNetEffect)) {
        <b
          [ngClass]="{
            'pnl-green': runnerPNetEffect >= 0,
            'pnl-red': runnerPNetEffect < 0,
          }"
          >&nbsp;&#xbb;&nbsp;{{ runnerPNetEffect | number: "1.2-2" }}</b
        >
      }
    </div>
  </div>
</td>
<td class="odd-cell">
  @if (pnlCalculator.hasPlacedBets(market?.selectionId, "fancy") | async) {
    <button mat-button (click)="pnlCalculator.showLinePnl(market?.selectionId, 'fancy')">P&L</button>
  }
</td>
<td class="odd-cell"></td>
@if (rowStatus && rowStatus !== "ACTIVE") {
  <td style="height: 56px; width: 134px" class="overlay-wrapper" colspan="2">
    <app-overlay [textStyle]="'font-size: 15px;'" [text]="rowStatus" />
  </td>
} @else {
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.no?.price,
          SIZE: row?.no?.spread,
          SIDE: 'LAY',
        })
      "
      class="value-cell bg-lay"
      [ngClass]="{ changed: row?.no?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.no?.price || "-" }}
      </span>
      <span class="value-size">{{ row?.no?.spread }}</span>
    </a>
  </td>
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.yes?.price,
          SIZE: row?.yes?.spread,
          SIDE: 'BACK',
        })
      "
      class="value-cell bg-back"
      [ngClass]="{ changed: row?.yes?.changed && priceChangeFlash }">
      <span class="value-price">
        {{ row?.yes?.price || "-" }}
      </span>
      <span class="value-size">{{ row?.yes?.spread }}</span>
    </a>
  </td>
}
<td class="odd-cell"></td>
<td class="odd-cell"></td>
